// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"addfda4c","455":"46569887","977":"b3362d2a"}[chunkId] + ".chunk.js";
};